<hlm-dialog-surface size="sm">
  <hlm-dialog-header>
    <hlm-dialog-icon-badge tone="primary">
      <hlm-icon name="lucideGlobe" size="1.1rem" />
    </hlm-dialog-icon-badge>
    <div hlmDialogHeading>
      <h2 hlmDialogTitle>Add domain — {{ data.brandName }}</h2>
      <p hlmDialogDescription>
        Register an allowed web domain for this brand.
      </p>
    </div>
    <button hlmDialogClose tabindex="-1" (click)="cancel()">
      <hlm-icon name="lucideX" size="1rem" />
    </button>
  </hlm-dialog-header>

  <section hlmDialogBody>
    <form id="brandDomainForm" class="flex flex-col gap-5" (ngSubmit)="submit()">

      <!-- Domain field with datalist autocomplete from global domains -->
      <label class="flex flex-col gap-1.5">
        <span class="cmt-eyebrow">Domain *</span>
        <input
          hlmInput
          type="text"
          [formControl]="domainControl"
          list="brand-domain-options"
          autocomplete="off"
          placeholder="audelia.com"
        />
        <datalist id="brand-domain-options">
          @for (g of globalDomains(); track g.domain) {
            <option [value]="g.domain"></option>
          }
        </datalist>
        @if (domainControl.hasError('domainFormat')) {
          <p class="text-sm text-destructive">
            Use a bare host like audelia.com — no http://, path, or port.
          </p>
        }
      </label>

      <!-- Mail domain toggle -->
      <div class="flex flex-col gap-1.5">
        <span class="cmt-eyebrow">Options</span>
        <hlm-checkbox [formControl]="mailDomainControl">
          Use as outgoing mail domain
        </hlm-checkbox>
      </div>

      <!-- Inline global-register panel — shown only when domain is new -->
      @if (needsGlobalRegister()) {
        <div class="rounded-lg border border-border bg-muted/40 p-3 flex flex-col gap-3">
          <div>
            <p class="cmt-eyebrow">Not registered globally yet</p>
            <p class="text-sm text-foreground leading-snug mt-1">
              This domain isn't in the global DOMAINS table. It will be registered
              first with the default brand below, then added to this brand.
            </p>
          </div>

          <!-- MX host (optional) -->
          <label class="flex flex-col gap-1.5">
            <span class="cmt-eyebrow">MX host (optional)</span>
            <input
              hlmInput
              type="text"
              [formControl]="mxControl"
              placeholder="mail.example.com"
              autocomplete="off"
            />
          </label>

          <!-- Default brand picker (required) -->
          <label class="flex flex-col gap-1.5">
            <span class="cmt-eyebrow">Default brand *</span>
            <select hlmNativeSelect [formControl]="defaultBrandControl">
              <option [ngValue]="null" disabled>— select brand —</option>
              @for (brand of brands(); track brand.id) {
                <option [ngValue]="brand.id">{{ brand.name }}</option>
              }
            </select>
            @if (defaultBrandControl.touched && defaultBrandControl.value === null) {
              <p class="text-sm text-destructive">A default brand is required.</p>
            }
          </label>

          <!-- Default sub-brand picker (optional) — scoped to sub-brands of the selected default brand -->
          <label class="flex flex-col gap-1.5">
            <span class="cmt-eyebrow">Default sub-brand</span>
            <select hlmNativeSelect [formControl]="defaultSubBrandControl">
              <option [ngValue]="null">— none —</option>
              @for (s of subBrandOptions(); track s.id) {
                <option [ngValue]="s.id">{{ s.name }}</option>
              }
            </select>
          </label>
        </div>
      }

      <!-- Inline error -->
      @if (errorMessage()) {
        <hlm-alert tone="error">
          <hlm-icon name="lucideCircleAlert" size="1rem" />
          {{ errorMessage() }}
        </hlm-alert>
      }

    </form>
  </section>

  <footer hlmDialogFooter>
    <button hlmBtn variant="outline" type="button" (click)="cancel()">Cancel</button>
    <button
      hlmBtn
      variant="default"
      type="submit"
      form="brandDomainForm"
      [disabled]="saving() || !canWrite()"
    >
      @if (saving()) {
        <hlm-spinner size="16" />
        Saving…
      } @else {
        <hlm-icon name="lucidePlus" size="0.9rem" />
        Add domain
      }
    </button>
  </footer>
</hlm-dialog-surface>
